// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-form {
  margin-bottom: 20px;
}

.feedback-subtitle {
  color: #666;
  margin-bottom: 30px;
  font-size: 0.95rem;
  line-height: 1.5;
}

.feedback-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.feedback-section h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.1rem;
}

.feedback-section:last-of-type {
  border-bottom: none;
}

.feedback-options {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.feedback-option {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.feedback-option:hover {
  border-color: #667eea;
  background-color: #f5f7ff;
}

.feedback-option.selected {
  border-color: #667eea;
  background-color: #f5f7ff;
}

.feedback-option input[type="radio"] {
  margin-right: 15px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #667eea;
}

.feedback-label {
  font-size: 0.95rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
}

.purchase-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
}

.purchase-option {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.purchase-option:hover {
  border-color: #667eea;
  background-color: #f5f7ff;
}

.purchase-option.selected {
  border-color: #667eea;
  background-color: #f5f7ff;
}

.purchase-option input[type="radio"] {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #667eea;
}

.purchase-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
}

.feedback-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 30px;
}

.submit-btn {
  padding: 12px 20px;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: opacity 0.3s;
}

.submit-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cancel-btn {
  padding: 12px 20px;
  font-size: 0.95rem;
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;
}

.cancel-btn:hover:not(:disabled) {
  background-color: #f5f7ff;
}

.cancel-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.feedback-note {
  text-align: center;
  color: #999;
  font-size: 0.85rem;
  margin-top: 15px;
}

@media (max-width: 600px) {
  .purchase-options {
    grid-template-columns: 1fr;
  }

  .feedback-actions {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FeedbackForm.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".feedback-form {\n  margin-bottom: 20px;\n}\n\n.feedback-subtitle {\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.feedback-section {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.feedback-section h3 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 1.1rem;\n}\n\n.feedback-section:last-of-type {\n  border-bottom: none;\n}\n\n.feedback-options {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.feedback-option {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.feedback-option:hover {\n  border-color: #667eea;\n  background-color: #f5f7ff;\n}\n\n.feedback-option.selected {\n  border-color: #667eea;\n  background-color: #f5f7ff;\n}\n\n.feedback-option input[type=\"radio\"] {\n  margin-right: 15px;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #667eea;\n}\n\n.feedback-label {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n}\n\n.purchase-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n}\n\n.purchase-option {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.purchase-option:hover {\n  border-color: #667eea;\n  background-color: #f5f7ff;\n}\n\n.purchase-option.selected {\n  border-color: #667eea;\n  background-color: #f5f7ff;\n}\n\n.purchase-option input[type=\"radio\"] {\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #667eea;\n}\n\n.purchase-label {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n}\n\n.feedback-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.submit-btn {\n  padding: 12px 20px;\n  font-size: 0.95rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: opacity 0.3s;\n}\n\n.submit-btn:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  padding: 12px 20px;\n  font-size: 0.95rem;\n  background: white;\n  color: #667eea;\n  border: 2px solid #667eea;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: background-color 0.3s;\n}\n\n.cancel-btn:hover:not(:disabled) {\n  background-color: #f5f7ff;\n}\n\n.cancel-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.feedback-note {\n  text-align: center;\n  color: #999;\n  font-size: 0.85rem;\n  margin-top: 15px;\n}\n\n@media (max-width: 600px) {\n  .purchase-options {\n    grid-template-columns: 1fr;\n  }\n\n  .feedback-actions {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
